







































































































import { Vue, Component, Watch } from "./vue-ext";

import { axiosInstance, authenticationService, termsOfUseService, statusService, onUnhandledServiceError, JsonRpcException } from "./services";
import { ApiStatus, AuthenticationStatus } from "./models";

import Login from "./components/Login.vue";

import TaskView from "./components/TaskView.vue";
import TermsView from "./views/TermsView.vue";

@Component({
    components: {
        Login,
        TaskView,
        TermsView
    }
})
export default class App extends Vue {
    state: "Loading" | "Login" | "Terms" | "Ready" = "Loading";

    language = "en";
    languageMenu = false;
    languages = ["fi", "sv", "en"];
    languageKey = "mobisulo.language";

    error: boolean = false;
    errorDetails: null | string = null;

    authentication: null | AuthenticationStatus = null;

    drawer = false;

    async mounted() {
        this.auth.roles = [];

        try {
            const language = localStorage.get(this.languageKey);

            if (this.languages.indexOf(language) !== -1) {
                this.language = language;
            }
        } catch {
            // Ignore
        }

        const skipLaunchDelay = !!this.$route.query.loadTaskId;
        if (!skipLaunchDelay && !window.location.host.endsWith(".local")) {
            // Ensure splash screen is displayed in production
            await new Promise(resolve => setTimeout(resolve, 2000));
        }

        onUnhandledServiceError((e: JsonRpcException) => {
            console.log(e);
            this.error = true;
            this.errorDetails = `${e.path}.${e.method}`;
        });

        await this.launch();

        this.startStatusPoll();
    }

    @Watch("state")
    stateChanged() {
        document.getElementById("splash")!.style.display = (this.state === "Loading" ? "flex" : "none");
    }

    setLanguage(language: string) {
        this.language = language;
        this.languageMenu = false;
    }

    @Watch("language")
    languageChanged() {
        localStorage.setItem(this.languageKey, this.language);
        axiosInstance.defaults.headers.common["Accept-Language"] = this.language;
        this.$i18n.locale = this.language;
        this.$vuetify.lang.current = this.language;
    }

    async launch() {
        this.state = "Loading";

        this.authentication = await authenticationService.getAuthenticationStatus();
        if (!this.authentication.isAuthenticated) {
            this.state = "Login";
            return;
        }

        // console.log("this.authentication.roles", this.authentication.roles);

        this.auth.roles = this.authentication.roles;

        if (this.authentication.language && this.languages.indexOf(this.authentication.language) !== -1) {
            this.language = this.authentication.language;
        }

        if (!(await termsOfUseService.getTermsOfUseStatus("Mobisulo")).accepted) {
            this.state = "Terms";
            return;
        }

        this.state = "Ready";
    }

    async startStatusPoll() {
        let lastStatus: ApiStatus = await statusService.getApiStatus();

        while (true) {
            await new Promise(r => setTimeout(r, 5 * 60 * 1000));

            try {
                const status = await statusService.getApiStatus();

                if (lastStatus.buildTimestamp !== status.buildTimestamp) {
                    window.location.reload();
                }

                lastStatus = status;
            } catch {
                // Ignore
            }
        }
    }

    async logout() {
        this.state = "Loading";

        await authenticationService.signOut();

        await new Promise(resolve => setTimeout(resolve, 2000));

        await this.launch();
    }
}
